import { Component, OnInit,ViewChild,TemplateRef } from '@angular/core';
import {NgbModal, ModalDismissReasons,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { HttpErrorResponse } from '@angular/common/http';
import {TopicService} from "../../service/topic.service";
import { ParamMap, Router, ActivatedRoute,Params } from '@angular/router';
import { commonService } from '../../service/common.service';
import { Globals } from '../../globals';

@Component({
  selector: 'app-populartopic',
  templateUrl: './populartopic.component.html',
  styleUrls: ['./populartopic.component.css'],
  providers:[TopicService]
})
export class PopulartopicComponent implements OnInit {

  isPostLoad=true;
  msg="";
  serachinput="";
  serachResult=[];
  popularTopiclist:any=[];
  modalReference:NgbModalRef;
  obj:any;

  constructor(private global:Globals,private _common:commonService,private modalService: NgbModal,private topicService:TopicService,private router: Router,private route: ActivatedRoute) { 
    this.obj={};
    this.obj.topiclist=[];

  }
  
  @ViewChild('topic') public topic: TemplateRef<any>;

  ngOnInit() {
   this.obj.topicurl= this.global.topicImageUrl;
    this._common.profile.subscribe((data:any)=>{
      if(typeof data=='object' &&  data!=null){
        this.obj.userData = data;
      }else{
        this.obj.userData={};
        
      } 
   })


    this.getPopularTopic();
  }

  getPopularTopic(){
    let obj={};
    this.topicService.getPopularTopic(obj).subscribe((data:any)=>{     
      if(data.error==0){
      this.popularTopiclist=data.results; 
      
      


      }

    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
    })
  }


  customdecode(data){   
    return encodeURI(btoa(data));
   }

   allSearch(){
    let obj={};   
    obj['search']=(this.serachinput)?this.serachinput:"";
    if(obj['search']!=''){
    this.topicService.getSearchResults(obj).subscribe((data:any)=>{
      if(data.error==0){
        this.serachResult=data.result;
      }
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
    })
  }else{

    this.serachResult=[];
  }
    
   }

   searchurl(search){
   
     this.serachinput="";
     this.serachResult=[];
    if(search.type=='userpost'){
      this.router.navigate(['forum/'+search.id]);
    }else if(search.type=='topic'){
      this.router.navigate(['topic/'+this.customdecode(search.id)]);
    }else if(search.type=='Technical Expert' || search.type=='HOD' || search.type=='Expert'){
      this.router.navigate(['profile/'+this.customdecode(search.id)]);
    }else if(search.type=='othertopic'){
      this.router.navigate(['otopic/'+this.customdecode(search.title)]);
    } else if(search.type=='group'){
      this.router.navigate(['groups/'+this.customdecode(search.id)]);
    }
   }

   openTopicForm(content){
    

    this.modalReference =  this.modalService.open(content,{size: 'lg',backdrop : 'static',
    keyboard : false }); 
    this.viewmoretopic();
    
   }


   viewmoretopic(){

    this.obj.viewmore=false;
    let objdata={};
    objdata['userId']=(this.obj.userData.id?this.obj.userData.id:0);
    objdata['offset']=this.obj.topiclist.length?this.obj.topiclist.length:0
    objdata['limit'] =5;
    this.topicService.getTopic(objdata).subscribe((data:any)=>{  
     this.isPostLoad=false;   
      if(data.error==0){
        //this.obj.topiclist=data.results.rows;  
        
        Array.prototype.push.apply( this.obj.topiclist,data.results.rows);
        if(data.results.count> this.obj.topiclist.length){
           this.obj.viewmore=true;
        }else{
         this.obj.viewmore=false;
        }
      }

    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
    })
   }

   topicFollow(topicDetail){
   
    let obj={topicId:topicDetail.id,userId:this.obj.userData.id};
    //console.log(obj);

    this.topicService.saveFollower(obj).subscribe((data:any)=>{
      if(data.error==0){
      topicDetail.mycount +=1;
      topicDetail.followerCount +=1;
      }
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
  
    })

    
   }
   topicUnFollow(topicDetail){

    let obj={topicId:topicDetail.id,userId:this.obj.userData.id};
    //console.log(obj);

    this.topicService.saveunFollower(obj).subscribe((data:any)=>{
      if(data.error==0){
      topicDetail.mycount -=1;
      topicDetail.followerCount -=1;
      }
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
  
    })
   }


   topicbookmark(topicDetail){
   
    let obj={topicId:topicDetail.id,userId:this.obj.userData.id};
    //console.log(obj);

    this.topicService.topicbookmark(obj).subscribe((data:any)=>{
      if(data.error==0){
      
      topicDetail.ismybookmark =1;
      }
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
  
    })

    
   }
   topicunbookmark(topicDetail){
    let obj={topicId:topicDetail.id,userId:this.obj.userData.id};
    //console.log(obj);

    this.topicService.topicunbookmark(obj).subscribe((data:any)=>{
      if(data.error==0){
        topicDetail.ismybookmark =0;
      }
    },(error:HttpErrorResponse)=>{
      this.msg="internal server error!";
  
    })
   }

  getTopicImage(path,width,height){
      if(!path){
        path='topic.png';
      }

  if(width!=undefined && height!=undefined){
    let res=this.global.websiteImgUrl+this.global.topicFolder+'/'+path+'&width='+width+'&height='+height;
    return res;
  }else{
    let res=this.global.websiteImgUrl+this.global.topicFolder+'/'+path;
    return res;
  }
    

  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/populartopic/populartopic.component.ts